<template>
  <div>
    <task-filter-bar @filter-change="onFilterChange" />

    <v-data-table
      :items="task_logs"
      :headers="headers"
      :search="search"
      :items-per-page="15"
      sort-by="log_date"
      sort-desc
      show-expand
      single-expand
    >
      <template v-slot:top>
        <v-text-field
          v-model="search"
          label="Search..."
          prepend-inner-icon="mdi-magnify"
          clearable
          dense
          outlined
          class="mb-2"
        ></v-text-field>
      </template>

      <template v-slot:item.log_date="{ item }">
        {{ item.log_date ? item.log_date.substr(0, 10) : "" }}
      </template>

      <template v-slot:item.user="{ item }">
        {{
          item.task && item.task.assigned_to_user
            ? item.task.assigned_to_user.full_name
            : ""
        }}
      </template>

      <template v-slot:item.title="{ item }">
        {{ item.task ? item.task.title : "" }}
      </template>

      <template v-slot:item.category="{ item }">
        {{ item.task ? item.task.category || "-" : "-" }}
      </template>

      <template v-slot:item.priority="{ item }">
        <v-chip
          :color="priorityColor(item.task ? item.task.priority : 'basic')"
          small
          dark
        >
          {{ priorityLabel(item.task ? item.task.priority : "basic") }}
        </v-chip>
      </template>

      <template v-slot:item.completed_at="{ item }">
        {{ item.completed_at ? formatDate(item.completed_at) : "-" }}
      </template>

      <template v-slot:item.acknowledged_at="{ item }">
        {{ item.acknowledged_at ? formatDate(item.acknowledged_at) : "-" }}
      </template>

      <!-- Status with remarks icon -->
      <template v-slot:item.status="{ item }">
        <v-chip :color="statusColor(item.status)" small dark>
          {{ statusLabel(item.status) }}
        </v-chip>
        <v-tooltip bottom v-if="item.remarks && item.remarks.length > 0">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small color="orange" class="ml-1"
              >mdi-comment-text-multiple</v-icon
            >
          </template>
          <span>{{ item.remarks.length }} remark(s)</span>
        </v-tooltip>
      </template>

      <!-- Expanded row: notes, comments, and remarks -->
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pa-4">
          <v-row dense>
            <v-col cols="4">
              <div class="caption grey--text">Completion Note:</div>
              <div>{{ item.completion_note || "No note provided" }}</div>
            </v-col>
            <v-col cols="4">
              <div class="caption grey--text">Admin Comment:</div>
              <div>{{ item.admin_comment || "No comment" }}</div>
              <div v-if="item.acknowledged_by_user" class="caption mt-1">
                - {{ item.acknowledged_by_user.full_name }}
              </div>
            </v-col>
            <v-col cols="4" v-if="item.remarks && item.remarks.length > 0">
              <div class="caption grey--text">Remarks:</div>
              <div v-for="(r, i) in item.remarks" :key="i" class="mb-1">
                <v-chip
                  x-small
                  :color="r.status_set === 'ongoing' ? 'orange' : 'grey'"
                  dark
                  class="mr-1"
                >
                  {{ r.status_set === "ongoing" ? "Ongoing" : "Pending" }}
                </v-chip>
                <span class="body-2">{{ r.remark }}</span>
                <div class="caption grey--text">
                  {{ r.user ? r.user.full_name : "" }} &middot;
                  {{
                    r.created_at ? new Date(r.created_at).toLocaleString() : ""
                  }}
                </div>
              </div>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TaskFilterBar from "./TaskFilterBar.vue";

export default {
  components: { TaskFilterBar },
  data() {
    return {
      search: "",
      headers: [
        { text: "Date", value: "log_date", width: "110" },
        { text: "User", value: "user", width: "150" },
        { text: "Task", value: "title" },
        { text: "Category", value: "category", width: "120" },
        { text: "Priority", value: "priority", width: "110" },
        { text: "Status", value: "status", width: "120" },
        { text: "Completed", value: "completed_at", width: "160" },
        { text: "Acknowledged", value: "acknowledged_at", width: "160" },
        { text: "", value: "data-table-expand" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      task_logs: "reminder/task_logs",
    }),
  },
  created() {
    // Load today's logs by default
    const today = new Date().toISOString().substr(0, 10);
    this.get_task_logs({ date_from: today, date_to: today });
  },
  methods: {
    ...mapActions({
      get_task_logs: "reminder/get_task_logs",
    }),
    onFilterChange(filters) {
      this.get_task_logs(filters);
    },
    formatDate(d) {
      if (!d) return "";
      return new Date(d).toLocaleString();
    },
    priorityColor(p) {
      return p === "very_urgent" ? "red" : p === "urgent" ? "orange" : "blue";
    },
    priorityLabel(p) {
      return p === "very_urgent"
        ? "Very Urgent"
        : p === "urgent"
        ? "Urgent"
        : "Basic";
    },
    statusColor(s) {
      const map = {
        pending: "grey",
        ongoing: "orange",
        completed: "blue",
        acknowledged: "green",
        missed: "red",
      };
      return map[s] || "grey";
    },
    statusLabel(s) {
      const map = {
        pending: "Pending",
        ongoing: "Ongoing",
        completed: "Submitted",
        acknowledged: "Acknowledged",
        missed: "Missed",
      };
      return map[s] || s;
    },
  },
};
</script>
